import React from 'react';
import {
  Box,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
} from '@mui/material';

const RM_second = () => {
  return (
    <Box
      sx={{
        width: '95%',
        py: 2,
        display: 'flex',
        gap: 2,
        boxSizing: 'border-box',
      }}
    >
      {/* Modeling Approaches */}
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600} sx={{ color: '#242424' }} >
          Modeling Approaches
        </Typography>
        <Typography variant="body2" mt={1}>
          To ensure robust, defendable market data, we apply both top-down and bottom-up modeling approaches.
        </Typography>

        <Grid container spacing={2} mt={1}>
          <Grid item xs={6}>
            <Typography variant="subtitle2" fontWeight={600}>
              Bottom-Up:
            </Typography>
            <List dense disablePadding>
              {[
                'Company-level revenue extraction',
                'Product and regional-level aggregation',
                'End-use market mapping by application and demand volume',
              ].map((text, idx) => (
                <ListItem key={idx} disableGutters>
                  <ListItemText primary={`• ${text}`} />
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2" fontWeight={600}>
              Top-Down:
            </Typography>
            <List dense disablePadding>
              {[
                'Sectoral production & consumption trends',
                'Application-level penetration & pricing',
                'Macro-alignment with GDP, trade data & investment cycles',
              ].map((text, idx) => (
                <ListItem key={idx} disableGutters>
                  <ListItemText primary={`• ${text}`} />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </Box>

      {/* Forecasting Tools */}
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600} sx={{ color: '#242424' }} >
          Forecasting Tools We Use
        </Typography>

        <List dense disablePadding sx={{ mt: 1 }}>
          {[
            'CAGR and scenario analysis (base, optimistic, stressed)',
            'Policy impact models (ESG mandates, regulatory shifts)',
            'Infrastructure development and consumer behavior outlooks',
            'Capex and product innovation curves for high-growth sectors',
          ].map((text, idx) => (
            <ListItem key={idx} disableGutters>
              <ListItemText primary={`• ${text}`} />
            </ListItem>
          ))}
        </List>

        <Typography variant="body2" mt={2}>
          Forecasts typically span 5-10 years, customized to industry-specific life cycles and investment rhythms.
        </Typography>
      </Box>
    </Box>
  );
};

export default RM_second;
